import { useContext } from "react";
import PlannerContext from "./PlannerContext";

export default function usePlanner() {
  const ctx = useContext(PlannerContext);
  if (!ctx) {
    throw new Error("usePlanner must be used inside <PlannerProvider>");
  }
  return ctx;
}
